import { createApp } from 'vue'

import PressApp from 'Root/vue/apps/press.vue'
import RequestStatusApp from 'Root/vue/apps/RequestStatus.vue'
import SearchResultsApp from 'Root/vue/apps/SearchResults.vue'
import HeaderSearchApp from 'Root/vue/apps/HeaderSearch.vue'
import StatisticsApp from 'Root/vue/apps/Statistics.js'
import ChequesApp from 'Root/vue/apps/Cheques.js'
import PublicStatisticsApp from 'Root/vue/apps/PublicStatistics.js'
import NewsletterApp from 'Root/vue/apps/Newsletter.js'

$(function () {
    if (document.querySelector('.press-app') && typeof window.pressAppData !== 'undefined') {
        const PressAppInstance = createApp(PressApp)

        PressAppInstance.config.globalProperties.appData = window.pressAppData

        PressAppInstance.mount('.press-app')
    }

    if (document.querySelector('.request-status-app') && typeof window.requestStatusAppData !== 'undefined') {
        const RequestStatusAppInstance = createApp(RequestStatusApp)

        RequestStatusAppInstance.config.globalProperties.appData = window.requestStatusAppData

        RequestStatusAppInstance.mount('.request-status-app')
    }

    if (document.querySelector('.search-results-app') && typeof window.searchResultsAppData !== 'undefined') {
        const SearchResultsAppInstance = createApp(SearchResultsApp)

        SearchResultsAppInstance.config.globalProperties.appData = window.searchResultsAppData

        SearchResultsAppInstance.mount('.search-results-app')
    }

    document.querySelectorAll('.header-search-app').forEach((element) => {
        if (typeof window.headerSearchAppData !== 'undefined') {
            const HeaderSearchAppInstance = createApp(HeaderSearchApp)

            HeaderSearchAppInstance.config.globalProperties.appData = window.headerSearchAppData

            HeaderSearchAppInstance.mount(element)
        }
    })

    if (document.querySelector('.statistics-app') && typeof window.statisticsAppData !== 'undefined') {
        const StatisticsAppInstance = createApp(StatisticsApp)

        StatisticsAppInstance.config.globalProperties.appData = window.statisticsAppData

        StatisticsAppInstance.mount('.statistics-app')
    }

    if (document.querySelector('.cheques-app') && typeof window.chequesAppData !== 'undefined') {
        const ChequesAppInstance = createApp(ChequesApp)

        ChequesAppInstance.config.globalProperties.appData = window.chequesAppData

        ChequesAppInstance.mount('.cheques-app')
    }

    if (document.querySelector('.public-statistics-app') && typeof window.publicStatisticsAppData !== 'undefined') {
        const PublicStatisticsAppInstance = createApp(PublicStatisticsApp)

        PublicStatisticsAppInstance.config.globalProperties.appData = window.publicStatisticsAppData

        PublicStatisticsAppInstance.mount('.public-statistics-app')
    }

    if (document.querySelector('.newsletter-app') && typeof window.newsletterAppData !== 'undefined') {
        const NewsletterAppInstance = createApp(NewsletterApp)

        NewsletterAppInstance.config.globalProperties.appData = window.newsletterAppData

        NewsletterAppInstance.mount('.newsletter-app')
    }
})
